(function ($) {
    var eventTileModalOpen = false;
    var eventTileModalObserver = null;
    var eventTileModalSelector =
        '.news-area-tematica-eventi .event-image-trigger.pat-plone-modal';

    function setEventTileModalClass() {
        if (!eventTileModalOpen) {
            return;
        }

        $('.plone-modal-wrapper .plone-modal-dialog')
            .last()
            .addClass('news-area-tematica-eventi-modal-dialog');
    }

    function stopEventTileModalObserver() {
        eventTileModalOpen = false;

        if (eventTileModalObserver) {
            eventTileModalObserver.disconnect();
            eventTileModalObserver = null;
        }
    }

    function startEventTileModalObserver() {
        eventTileModalOpen = true;
        setEventTileModalClass();

        if (eventTileModalObserver) {
            eventTileModalObserver.disconnect();
        }

        if (!window.MutationObserver) {
            setTimeout(setEventTileModalClass, 0);
            setTimeout(setEventTileModalClass, 100);
            setTimeout(setEventTileModalClass, 300);
            return;
        }

        eventTileModalObserver = new window.MutationObserver(function () {
            setEventTileModalClass();
        });

        eventTileModalObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    document.addEventListener(
        'click',
        function (e) {
            if ($(e.target).closest(eventTileModalSelector).length) {
                startEventTileModalObserver();
            }
        },
        true
    );

    $(document).on('shown shown.bs.modal', '.plone-modal', function () {
        setEventTileModalClass();
    });

    $(document).on('click', '.plone-modal-close', stopEventTileModalObserver);
    $(document).on(
        'hidden hidden.bs.modal',
        '.plone-modal',
        stopEventTileModalObserver
    );
})(jQuery);
